import PayloadRegister from './PayloadRegister';
import fetchAppToken from './fetchAppToken';
import { BackendResponse, FetchOptions } from './types';

/**
 * Default Method is GET
 * @param url
 * @param options
 */
const backendFetch = async <Value>(
  url: string,
  options: FetchOptions,
): Promise<void | BackendResponse<Value>> => {
  if (!url) throw new Error('Missing URL!');

  let requestHeaders: Record<string, string> = {};
  if (Object.keys(options?.headers || {}).length) {
    requestHeaders = options.headers;
  }

  if (PayloadRegister.isProduction()) {
    const appToken = await fetchAppToken();
    requestHeaders.Authorization = `JWT ${appToken}`;
  }

  const {
    method = 'GET',
    body,
    bodyOptions,
  } = options;

  let requestBody: Record<string, unknown> | null = null;

  switch (method) {
    case 'POST':
    case 'PUT':
    case 'PATCH':
      if (body && typeof body !== 'object') {
        throw new Error('Expected body parameter to be an object');
      }
      if (!bodyOptions?.allowEmpty && Object.keys(body).length === 0) {
        throw new Error('Empty Body!');
      }

      requestHeaders['Content-Type'] = 'application/json; charset=UTF-8';
      requestBody = body;
      break;
    case 'DELETE':
    case 'GET':
      break;
    default:
      throw new Error(`Unknown method: "${method}"`);
  }

  const request = {
    body: undefined,
    headers: requestHeaders,
    method: method,
  };

  if (requestBody) {
    request.body = JSON.stringify(requestBody);
  }

  return PayloadRegister.checkForPayload(url, request).then(async (response: Response) => {
    const {
      status,
      ok,
      headers,
    } = response;

    if (ok) {
      if (status === 204) {
        return {
          status,
          ok,
          headers,
          data: {
            value: 'deleted',
          },
        };
      }

      return {
        status,
        ok,
        headers,
        data: await response.json(),
      };
    }

    // Couldn't process request
    throw response;
  }).catch((error: Error) => {
    if (error.name === 'AbortError') {
      console.log('Call got cancelled!');
      return;
    }

    console.error('Failed calling url: ', url);
    console.error('With request: ', request);
    console.error(error);
  });
};

export default backendFetch;
